
export default "/assets/user-group-mini.9756e987.svg"